import React from 'react';
import {
  InputStyled,
  InputNumberStyled as InputNumber,
  TextAreaStyled as TextArea,
  PasswordStyled as InputPassword
} from './styled';

function Index(props) {
  return <InputStyled {...props} />;
}

export { InputNumber, TextArea, InputPassword };

export default Index;
